import { createI18n } from 'vue-i18n';
import axios from 'axios';
import { mainDomain } from '@/utils/variables';
// Initialize the i18n instance
const i18n = createI18n({
    legacy: false, // Use the Composition API
    locale: 'en', // Default locale
    fallbackLocale: 'en',
    messages: {} // Initially empty
});

// Function to load locale messages
export const loadLocaleMessages = async (locale: string) => {
    try {
        const response = await axios.get(`/main-api/translations/${locale}?domain=${mainDomain}`);
        // const responseLegal = await axios.get(`/api/translations/legal-pages/${locale}`);

        // const messages = responseLegal.status === 200 ? { ...response.data, ...responseLegal.data } : response.data;
        const messages = response.data;

        // Set the locale and messages in i18n
        i18n.global.setLocaleMessage(locale, messages);
        i18n.global.locale.value = locale; // Set the current locale
        document.querySelector('html')?.setAttribute('lang', locale);
    } catch (error) {
        console.error('Failed to load translations:', error);
    }
};

export default i18n;
